import { WeekCloseView } from './WeekCloseView.jsx';
import { PayrollReportView } from './PayrollReportView.jsx';
import { WeeklyCashCountView } from './WeeklyCashCountView.jsx';
import { IncidentTriageView } from './IncidentTriageView.jsx';
import { IncidentReportView } from './IncidentReportView.jsx';
import { ChatView } from './ChatView.jsx';
import { BoardView } from './BoardView.jsx';
import { ShiftHandoffReportView } from './ShiftHandoffReportView.jsx';
import { ShiftHandoffQueue } from './ShiftHandoffQueue.jsx';
import { ManagerTodoView } from './ManagerTodoView.jsx';
import { BeforeYouGo } from './BeforeYouGo.jsx';
import { ShiftStandardsSettings } from './ShiftStandardsSettings.jsx';
import { ShiftHandoffNotes } from './ShiftHandoffNotes.jsx';
import { HandoffReportsDue } from './HandoffReportsDue.jsx';
import { MyShift } from './MyShift.jsx';
import { StockAuditView } from './StockAuditView.jsx';
import { FleetView } from './FleetView.jsx';
import { StoreCheckView } from './StoreCheckView.jsx';

// The tab-to-view mount table, lifted verbatim out of Dashboard.jsx.
//
// MOVE ONLY — every condition and every prop is byte-identical to what was
// inline. Dashboard.jsx sat exactly on its ratchet ceiling (1257) and fails on
// the first line added, so nothing new could be mounted there without a split
// first. That is the ratchet working as designed; this is the split.
//
// Reformatting the block to buy a dozen lines would have been gaming the
// number rather than decomposing the file, which is the thing the ratchet
// exists to prevent.
export function TabMounts({
  activeTab, user, locations,
  isOwner, isManager, canEnterCashCount,
}) {
  return (
    <>
      {activeTab === 'reports-payroll' && isManager && (
        <PayrollReportView currentUser={user} />
      )}
      {activeTab === 'reports-week-close' && isManager && (
        <WeekCloseView user={user} />
      )}
      {activeTab === 'reports-cash-counts' && canEnterCashCount && (
        <WeeklyCashCountView currentUser={user} />
      )}
      {activeTab === 'reports-incidents' && isManager && (
        <IncidentTriageView currentUser={user} locations={locations} />
      )}
      {/* Stock audit (docs/STOCK-SPEC.md Phase 0). Manager+, matching the
          manage_stock_config gate the route enforces server-side. */}
      {activeTab === 'reports-stock' && isManager && (
        <StockAuditView currentUser={user} />
      )}
      {/* Pi dashboard (empire-kds-label D296): owners + managers, view_fleet server-side. */}
      {activeTab === 'ops-pis' && isManager && (
        <FleetView locations={locations} isOwner={isOwner} />
      )}
      {/* Store Check (cameras D358): owners + managers, view_store_check server-side. */}
      {activeTab === 'ops-store-check' && isManager && (
        <StoreCheckView isOwner={isOwner} />
      )}
      {activeTab === 'report-incident' && (
        <IncidentReportView currentUser={user} locations={locations} />
      )}
      {/* Shift handoff (D247). Reporting is open to everyone — an opener who
          walks into an undone close is exactly who needs it. The queue is
          manager-gated, and separate from the injury queue on purpose. */}
      {activeTab === 'report-handoff' && (
        <ShiftHandoffReportView currentUser={user} locations={locations} />
      )}
      {activeTab === 'reports-handoff' && isManager && (
        <ShiftHandoffQueue currentUser={user} />
      )}
      {activeTab === 'manager-todo' && isManager && (
        <ManagerTodoView currentUser={user} />
      )}
      {/* Before you go (D249) — renders under the task list for everyone,
          because the standards are every employee's, not a manager thing.
          Returns null outside a shift period or when no standards exist. */}
      {/* The staff to-do list lives in two places on purpose: its own named
          destination (my-todo), and the Task list, where the "before you go"
          checklist belongs next to the tasks.
          CJ 2026-08-10: it was ALSO on home-daily, which put it on screen twice
          for anyone who had both open — "remove it from the daily menu and leave
          the separate my to-do". Adding it to the landing page was my fix for
          staff not finding it; the named nav entry is the fix that actually
          worked, and the extra mount was redundant. */}
      {(activeTab === 'today' || activeTab === 'my-todo') && (
        <>
          <MyShift currentUser={user} />
          {/* Hand-off notes sit ABOVE the before-you-go checklist: what the
              last shift needs you to know comes before what you owe the next
              one. Its own card rather than a row inside MyShift, because
              MyShift goes quiet when there is nothing to do and the composer
              has to stay reachable on a shift with nothing else outstanding. */}
          {/* Managers: handoff REPORTS waiting to be acknowledged, acked
              against the report itself (CJ 2026-09-30). */}
          {isManager && <HandoffReportsDue currentUser={user} />}
          <ShiftHandoffNotes currentUser={user} />
          <BeforeYouGo currentUser={user} />
        </>
      )}
      {activeTab === 'settings-shift-standards' && isManager && (
        <ShiftStandardsSettings currentUser={user} />
      )}
      {activeTab === 'chat' && (
        <ChatView currentUser={user} />
      )}
      {activeTab === 'board' && (
        <BoardView user={user} locations={locations} />
      )}
    </>
  );
}
